import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { ECard, TITLES_BLOCK } from "../../../utils/constants";
import { selectCurrentTariff, selectIsRenderResultBlock, selectTariffs, withCardsTariffsMapper } from "../../../../../store/slices/search/selectors";
import { CellCard, CommonBlock } from "../../CommonBlock";
import { withAnalyticsCard } from "../../../hocs/withAnalyticsCard";
export var TariffBlock = compose(connect(function (state) {
  return {
    title: TITLES_BLOCK.tariff,
    shouldRender: !!selectTariffs(state).length && selectIsRenderResultBlock(state)
  };
}), withCardsTariffsMapper, withRenderFlag)(CommonBlock);
export var TariffCard = compose(connect(function (state) {
  return {
    item: selectCurrentTariff(state)
  };
}), withAnalyticsCard({
  element_type: ECard.tariff
}))(CellCard);